// extracted by mini-css-extract-plugin
export var equalColumn = "_ii-0";